export const GET_DEFAULT_PERMISSION_GROUPS_START =
  'GET_DEFAULT_PERMISSION_GROUPS_START';
export const GET_DEFAULT_PERMISSION_GROUPS_SUCCESS =
  'GET_DEFAULT_PERMISSION_GROUPS_SUCCESS';
export const GET_DEFAULT_PERMISSION_GROUPS_FAILURE =
  'GET_DEFAULT_PERMISSION_GROUPS_FAILURE';
